<template>
    <VJoyWrapper class="project-indicator" no-margin column-gap="1" wrap="nowrap">
        <VJoyIcon name="hand-check" color="neutral-50" size="xsmall" />
        <span class="project-indicator__text" :class="{'project-indicator__text--bold': mf}">
            {{
                t('profile.header.project.indicator.label', {
                    count: nbProjects,
                })
            }}
        </span>
    </VJoyWrapper>
</template>
<script setup lang="ts">
    import {useTranslation} from '#imports';
    import {VJoyIcon, VJoyWrapper} from '@maltjoy/core-vue';

    defineProps<{
        nbProjects: number;
        mf?: boolean;
    }>();
    const {t} = useTranslation();
</script>

<style scoped lang="scss">
    .project-indicator {
        &__text {
            white-space: nowrap;

            &--bold {
                font-weight: var(--joy-font-weight-bold);
            }
        }
    }
</style>
